"use client"

import Link from "next/link";
import { useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";

function Footer({ blok }) {
  const navigate = useRouter();
  // Adding the gradient animation keyframes as inline style
  const footerStyles = `
    @keyframes gradientFlow {
  0% {
    background-position: 100% 50%; /* Start from right */
  }
  100% {
    background-position: 0% 50%; /* Move to left */
  }
}
  `;

  return (
    <footer
      className="text-white py-12 lg:mt-0 "
      style={{
        background: `linear-gradient(
          90deg,
          #672C7B 0%,    /* Start with dark purple */
          #6D2F80 15%,   /* Intermediate soft purple */
          #493989 35%,   /* Shift to deep blue-purple */
          #4E3C92 50%,   /* Smooth blue transition */
          #493989 65%,   /* Keep consistency in blue-purple */
          #6D2F80 85%,   /* Return to soft purple */
          #672C7B 100%   /* End with dark purple */
        )`,
        backgroundSize: "800% 100%", // Makes the gradient wider than the container
        animation: "gradientFlow 15s linear infinite",
      }}
    >
      {/* Injecting the keyframes in a <style> tag */}
      <style>{footerStyles}</style>

      <div className="mx-auto lg:px-0 px-4 max-w-7xl">
        {/* Footer Main Section */}
        <div className="grid lg:grid-cols-5 gap-8 mb-12 ">
          {/* Logo and Description Section */}
          <div>
            <a href="/">
            <img
              src={blok?.FooterImages[0].filename}
              alt={blok?.FooterImages[0].alt}
              className="h-8 mb-10"
            />
            </a>
            <p className="text-[16px] mb-10">{blok.FooterDescription}</p>

            {/* Social Media Links */}
            <div className="flex mb-[-58px]">
              <a
                href="https://www.youtube.com/channel/UCUbeF1KnED2KR87b74moVng"
                target="_blank"
                rel="noopener noreferrer"
                className="lg:w-24 lg:h-24 ml-[-20px]"
              >
                <img
                  src={blok?.FooterImages[4].filename}
                  alt={blok?.FooterImages[4]?.alt}
                />
              </a>
              <a
                href="https://www.facebook.com/securininc/"
                target="_blank"
                rel="noopener noreferrer"
                className="lg:w-24 lg:h-24 ml-[-60px]"
              >
                <img
                  src={blok?.FooterImages[5].filename}
                  alt={blok?.FooterImages[5]?.alt}
                />
              </a>
              <a
                href="https://www.instagram.com/securininc/"
                target="_blank"
                rel="noopener noreferrer"
                className="lg:w-24 lg:h-24 ml-[-60px]"
              >
                <img
                  src={blok?.FooterImages[1].filename}
                  alt={blok?.FooterImages[1]?.alt}
                />
              </a>
              <a
                href="https://www.linkedin.com/company/securin-inc"
                target="_blank"
                rel="noopener noreferrer"
                className="lg:w-24 lg:h-24 ml-[-60px]"
              >
                <img
                  src={blok?.FooterImages[3].filename}
                  alt={blok?.FooterImages[3]?.alt}
                />
              </a>
              <a
                href="https://x.com/securin_inc"
                target="_blank"
                rel="noopener noreferrer"
                className="lg:w-24 lg:h-24 ml-[-60px]"
              >
                <img
                  src={blok?.FooterImages[2].filename}
                  alt={blok?.FooterImages[2]?.alt}
                />
              </a>
            </div>
          </div>

          {/* Contact Info Section */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <p className="text-sm">
              {"2440 Louisiana Blvd NE"} <br /> {" #560, Albuquerque, NM"}{" "}
              <br /> {"87110"}
            </p>
            <br />
            <Link to="tel:+1-505-302-1113" className="text-sm">505-302-1113</Link>
            <br />
            <Link to="mailto:info@securin.io" className="text-sm hover:text-gray-300">
                  info@securin.io
                </Link>
          </div>

          {/* Solutions Section */}
          <div>
            <h4 className="text-lg font-bold mb-4">Solutions</h4>
            <ul>
              <li className="pb-2">
                <div
                  onClick={() => {
                    navigate("/attack-surface-management");
                    window.scrollTo(0, 0);
                  }}
                  className="text-sm hover:text-gray-300 cursor-pointer"
                >
                  Attack Surface Management
                </div>
              </li>
              <li className="pb-2">
                <div
                  onClick={() => {
                    navigate("/vulnerability-intelligence");
                    window.scrollTo(0, 0);
                  }}
                  className="text-sm hover:text-gray-300 cursor-pointer"
                >
                  Vulnerability Intelligence
                </div>
              </li>
              <li className="pb-2">
                <div
                  onClick={() => {
                    navigate("/vulnerability-management");
                    window.scrollTo(0, 0);
                  }}
                  className="text-sm hover:text-gray-300 cursor-pointer"
                >
                  Vulnerability Management
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/penetrationtesting");
                    window.scrollTo(0, 0);
                  }}
                  className="text-sm hover:text-gray-300 cursor-pointer"
                >
                  Penetration Testing
                </div>
              </li>
            </ul>
          </div>

          {/* Resources Section */}
          <div>
            <h4 className="text-lg font-bold mb-4">Resources</h4>
            <ul>
              <li className="pb-2">
                <a href="#" className="text-sm hover:text-gray-300">
                  Zero Days
                </a>
              </li>
              <li className="pb-2">
                <div
                  onClick={() => {
                    navigate("/articles");
                    window.scrollTo(0, 0);
                  }}
                  className="text-sm hover:text-gray-300 cursor-pointer"
                >
                  Articles
                </div>
              </li>
              <li>
                <a href="#" className="text-sm hover:text-gray-300">
                  Patch Watch
                </a>
              </li>
            </ul>
          </div>

          {/* Company Section */}
          <div>
            <h4 className="text-lg font-bold mb-4">Company</h4>
            <ul>
              <li className="pb-2">
                <div
                  onClick={() => {
                    navigate("/about-us");
                    window.scrollTo(0, 0);
                  }}
                  className="text-sm hover:text-gray-300 cursor-pointer"
                >
                  Who We Are
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/careers");
                    window.scrollTo(0, 0);
                  }}
                  className="text-sm hover:text-gray-300 cursor-pointer"
                >
                  Careers
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <hr className="border-t border-white my-8 lg:max-w-[2000px] lg:ml-[-60px]" />

        {/* Footer Bottom Section */}
        <div className="lg:flex lg:justify-between lg:items-center w-[70%] lg:ml-[12%]">
          {/* Copyright */}
          <p className="text-[10px] lg:text-sm">
            © Copyright {new Date().getFullYear()} Securin. All Rights Reserved.
          </p>

          {/* Legal Links */}
          <div className="lg:flex gap-4 mt-6 lg:mt-0 lg:space-x-6">
            <div>
              <div
                onClick={() => {
                  navigate("/privacy-policy");
                  window.scrollTo(0, 0);
                }}
                className="text-[10px] lg:text-sm hover:text-gray-300 cursor-pointer"
              >
                Privacy Policy
              </div>
            </div>
            <div>
              <div
                onClick={() => {
                  navigate("/privacy-policy");
                  window.scrollTo(0, 0);
                }}
                className="text-[10px] lg:text-sm hover:text-gray-300 cursor-pointer"
              >
                Terms of Use
              </div>
            </div>
            <div>
              <div
                onClick={() => {
                  navigate("/customer-agreements");
                  window.scrollTo(0, 0);
                }}
                className="text-[10px] lg:text-sm hover:text-gray-300 cursor-pointer"
              >
                Customer Agreements
              </div>
            </div>
            <div>
              <div
                onClick={() => {
                  navigate("/privacy-policy");
                  window.scrollTo(0, 0);
                }}
                className="text-[10px] lg:text-sm hover:text-gray-300 cursor-pointer"
              >
                Site Map
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
